module.exports = __webpack_public_path__ + "static/media/6-min.bdb28a17.png";